import { parseNumberInputValue } from './parseNumberInput';

export const validateDecimalInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  nbrOfDecimals?: number,
) => {
  const parsedValue = parseNumberInputValue(event.currentTarget.value);

  if (typeof parsedValue === 'number') {
    return nbrOfDecimals !== undefined
      ? parseFloat(parsedValue.toFixed(nbrOfDecimals))
      : parseFloat(parsedValue.toFixed(2));
  }

  return undefined;
};
